import { z } from 'zod';

import { APP_CATEGORIES } from '../integration-app.js';

/**
 * The connectable-app catalogue as the SPA sees it - COW-491.
 *
 * `/v1/apps`, flat and plural like every resource after `/v1/members`
 * (ADR-030). No workspace in the path and none in the payload: the catalogue is
 * global, so the answer is the same for every caller who may see it.
 */
export const integrationAppSchema = z
  .object({
    appKey: z.string(),
    name: z.string(),
    category: z.enum(APP_CATEGORIES).optional(),
    iconUrl: z.url().optional(),
    capabilityCount: z.number().int().nonnegative(),
  })
  .readonly();

export type IntegrationAppSummary = z.infer<typeof integrationAppSchema>;

export const integrationAppListResponseSchema = z
  .object({ apps: z.array(integrationAppSchema).readonly() })
  .readonly();

export type IntegrationAppListResponse = z.infer<typeof integrationAppListResponseSchema>;
